import { useMutation, useQuery } from 'react-query'
import API from '.'
import { serializeQuery } from './utils'

const ENDPOINT = '/api/whatsapp-broadcast'
const QUERY_KEY = 'whatsapp-broadcast'

export const useGetWhatsappTemplates = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'templates', query],
    async () => (await API.get(serializeQuery(`${ENDPOINT}/templates`, query))).data,
    config,
  )

export const useGetWhatsappBroadcastJob = (jobId, config = {}) =>
  useQuery(
    [QUERY_KEY, 'jobs', jobId],
    async () => (await API.get(`${ENDPOINT}/jobs/${jobId}`)).data,
    config,
  )

export const useUploadWhatsappMedia = (config = {}) =>
  useMutation((formData) => API.post(`${ENDPOINT}/media`, formData), config)

export const useSendWhatsappBroadcast = (config = {}) =>
  useMutation((payload) => API.post(`${ENDPOINT}/send`, payload), config)
